import styled from 'styled-components'

export default styled.p`
  margin-top: 0;
  font-size: 1rem;
  ${props => (props.nomargin ? 'margin-bottom: 0' : null)};
  ${props => (props.muted ? `opacity: 0.5` : null)};
`
